import { useProductsTFunction } from '@retail/products/i18n';
import { Skeleton, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import { documentationKeys } from './helpers';
import { environmentKeys } from '../Environment/helpers';
import { StyledHeadTableCell, StyledKeyTableCell, StyledTableCell } from '../styles';

const placeholderColumns = [0, 1, 2];

interface Props {
  title: string;
  keys: string[];
}

const SkeletonSection = ({ title, keys }: Props) => (
  <>
    <TableHead>
      <TableRow>
        <StyledHeadTableCell sx={{ paddingLeft: (theme) => theme.spacing(6), textWrap: 'nowrap' }}>
          {title}
        </StyledHeadTableCell>
        {placeholderColumns.map((column) => (
          <StyledHeadTableCell key={column} align="center">
            <Skeleton width={100} sx={{ mx: 'auto' }} />
          </StyledHeadTableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {keys.map((key, rowIndex) => (
        <TableRow key={key}>
          <StyledKeyTableCell index={rowIndex}>
            <Skeleton width={180} />
          </StyledKeyTableCell>
          {placeholderColumns.map((column) => (
            <StyledTableCell key={column} align="center" index={rowIndex}>
              <Skeleton width={24} sx={{ mx: 'auto' }} />
            </StyledTableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </>
);

export const DocumentationTableSkeleton = () => {
  const t = useProductsTFunction();

  return (
    <TableContainer sx={{ pb: 1 }}>
      <Table sx={{ gap: 2 }}>
        <SkeletonSection
          title={t('products.mgItem.documentation.title')}
          keys={documentationKeys}
        />
        <SkeletonSection
          title={t('products.mgItem.environmentDocumentation.title')}
          keys={environmentKeys}
        />
      </Table>
    </TableContainer>
  );
};
